<template>
  <div class="row">
    <div class="col">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div class="table-responsive">
          <table class="table dataTable m-0 p-0 text-nowrap ">
            <thead class="bg-white">
              <tr>
                <th>Role Name</th>
                <th>Status</th>
                <th>Assigned Users</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div
                    class="text-center"
                    style="padding-top: 100px; padding-bottom: 50px"
                  >
                    <span
                      class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                      style="font-size: 8rem"
                    ></span>
                    <h3
                      class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px"
                    >
                      Please wait while we loading the User's Lists
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="l in roles" :key="l.id" v-else>
                <td>
                  {{ l.roleName }}
                </td>
                <td>
                  <span
                    class="flex items-center gap-[4px] max-w-max w-full"
                    :class="[
                      'badge',
                      {
                        'badge-success': l.numberOfAssignedUsers > 0,
                        'badge-danger': l.numberOfAssignedUsers <= 0,
                      },
                    ]"
                  >
                    <span
                      class="w-[10px] h-[10px] rounded-[1px]"
                      :style="{
                        backgroundColor:
                          l.numberOfAssignedUsers > 0 ? '#16a249' : '#EF5253',
                      }"
                    ></span>
                    <span class="text-[12px] font-normal leading-[16.94px]">{{
                      l.numberOfAssignedUsers > 0 ? "Assigned" : "Not Assigned"
                    }}</span>
                  </span>
                </td>
                <td>{{ l.numberOfAssignedUsers }}</td>
                <td>{{ formatDate(l.created) }}</td>
                <td>
                  <div class="dropdown">
                    <button
                      class="btn-no-border"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span
                        class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                      >
                        ...
                      </span>
                    </button>
                    <ul
                      class="dropdown-menu shadow-none"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <li
                        @click="viewRoleUsers(l)"
                        v-if="
                          hasPermission('Role_User_View') &&
                            l.numberOfAssignedUsers > 0
                        "
                        class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[10px] px-[16px]"
                      >
                        View Assigned Users
                      </li>
                      <li
                        @click="viewEdit(l)"
                        v-if="
                          l.parentId == user.parentId &&
                            hasPermission('Role_Update')
                        "
                        class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[10px] px-[16px]"
                      >
                        Edit Role
                      </li>
                      <li
                        v-if="
                          hasPermission('Role_Delete') &&
                            l.roleName.toLowerCase() != 'administrator' &&
                            l.roleName.toLowerCase() != 'support specialist' &&
                            l.roleName.toLowerCase() != 'view only' &&
                            l.roleName.toLowerCase() != 'sales'
                        "
                        class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[10px] px-[16px]"
                        @click="deleteRole(l)"
                      >
                        Delete Role
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr v-if="!roles.length && !loading">
                <td colspan="5">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-crosshairs-gps"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    You don't have any roles.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-add" role="dialog">
      <div
        class="modal-dialog p-0 m-0 fixed overflow-y-scroll top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content  h-full md:min-h-screen rounded-none bg-[#f8f8f8] p-[40px]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px capitalize text-[#353535] pb-[16px]"
            >
              Create New Role
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div>
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Role Name</label
              >
              <div>
                <input
                  :class="[{ 'is-invalid': v1.name }]"
                  type="text"
                  v-model="createRole.name"
                  class="bg-[[#fcfcfd]] border-[##96a0b5] border-solid border-[1.5px] py-[14px] px-[16px] md:px-[24px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
                  placeholder="Enter role name"
                />
                <ul v-if="v1.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mt-[16px]">
              <div>
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Permissions</label
                >
                <div
                  class="bg-white w-full"
                  style="height: 360px; overflow-y: scroll"
                >
                  <ol
                    v-if="permissionsListCreate.length > 0"
                    class="flex flex-col gap-[5px] w-full"
                  >
                    <li v-for="item in permissionsListCreate" :key="item.id">
                      <div
                        class="flex items-center justify-between gap-[5px] py-[14px] px-[10px] border-b border-[#eee] cursor-pointer"
                        @click="item.state.opened = !item.state.opened"
                      >
                        <input
                          type="checkbox"
                          :disabled="item.state.disabled"
                          :name="item.text"
                          :checked="item.state.selected"
                          class="custom-checkbox"
                          @click.stop="
                            item.state.selected = !item.state.selected
                          "
                          @change="
                            onPermissionChange(item, item.state.selected)
                          "
                        />
                        <label
                          :for="item.text"
                          class="text-[#353535] font-medium text-[16px] m-0 w-full"
                          >{{ item.text }}</label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300"
                          :class="item.state.opened ? 'rotate-180' : 'rotate-0'"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                      <ol v-if="item.children.length != 0 && item.state.opened">
                        <li
                          v-for="children in item.children"
                          :data-id="children.id"
                          class="border-b border-[#eee]w-full py-[11px]"
                          :key="children.id"
                        >
                          <div class="px-[28px] flex items-center gap-[8px]">
                            <input
                              type="checkbox"
                              :name="children.text"
                              :checked="children.state.selected"
                              :disabled="children.state.disabled"
                              class="custom-checkbox"
                              @click="
                                children.state.selected = !children.state
                                  .selected
                              "
                            />
                            <label
                              :for="children.text"
                              class="text-[#353535] font-normal text-[14px] m-0 w-full"
                              >{{ children.text }}</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="create"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add Role</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-edit" role="dialog">
      <div
        class="modal-dialog m-0 p-0 fixed overflow-y-scroll top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] p-[40px] md:min-h-screen"
        >
          <div
            class="modal-header modal-header-colored flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Editing Distributor Manager Role
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div>
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Role Name</label
              >
              <div>
                <input
                  :class="[{ 'is-invalid': v2.name }]"
                  type="text"
                  v-model="updateRole.name"
                  class="bg-[[#fcfcfd]] border-[##96a0b5] border-solid border-[1.5px] py-[14px] px-[16px] md:px-[24px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
                  placeholder="Enter role name"
                />
                <ul v-if="v2.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div class="mt-[16px]">
              <div>
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Permissions</label
                >
                <div
                  class="bg-white w-full"
                  style="height: 380px; overflow-y: scroll;"
                >
                  <ol class="flex flex-col gap-[5px] w-full">
                    <li v-for="item in permissionsListUpdate" :key="item.id">
                      <div
                        class="flex items-center justify-between gap-[5px] py-[14px] px-[10px] border-b border-[#eee] cursor-pointer"
                        @click="item.state.opened = !item.state.opened"
                      >
                        <input
                          type="checkbox"
                          :disabled="item.state.disabled"
                          :name="item.text"
                          :checked="item.state.selected"
                          class="custom-checkbox"
                          @click.stop="
                            item.state.selected = !item.state.selected
                          "
                          @change="
                            onPermissionChange(item, item.state.selected)
                          "
                        />
                        <label
                          :for="item.text"
                          class="text-[#353535] font-medium text-[16px] m-0 w-full"
                          >{{ item.text }}</label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300"
                          :class="item.state.opened ? 'rotate-180' : 'rotate-0'"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                      <ol v-if="item.children.length != 0 && item.state.opened">
                        <li
                          v-for="children in item.children"
                          :data-id="children.id"
                          class="border-b border-[#eee] w-full py-[11px]"
                          :key="children.id"
                        >
                          <div class="px-[28px] flex items-center gap-[8px]">
                            <input
                              type="checkbox"
                              :name="children.text"
                              :checked="children.state.selected"
                              :disabled="children.state.disabled"
                              class="custom-checkbox"
                              @click="
                                children.state.selected = !children.state
                                  .selected
                              "
                            />
                            <label
                              :for="children.text"
                              class="text-[#353535] font-normal text-[14px] m-0 w-full"
                              >{{ children.text }}</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              @click="cancel"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="update"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-filter"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1"><b>Filter</b></h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Status</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <select
                  class="form-control"
                  placeholder="Select an option"
                  v-model="filter.status"
                >
                  <option value="0">All Roles</option>
                  <option value="True">Active</option>
                  <option value="False">Disabled</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Other filters</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Filter by code or name..."
                  v-model="filter.qry"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary md-close"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 100px"
              class="btn btn-secondary md-close"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              style="width: 100px"
              class="btn btn-primary md-close"
              type="button"
              @click="getRoles"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <ViewAsignedRole
      :roleUsers="roleUsers"
      :roleInfo="roleInfo"
      v-if="isModalVisible"
      :close="closeModal"
    />
    <DeleteCaution
      :roleId="roleId"
      :role="role"
      @deletion-success="handleDeletionSuccess"
    />
  </div>
</template>

<style scoped>
.custom-checkbox {
  width: 24px;
  height: 18.9px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Pagination from "../Pagination.vue";
import ViewAsignedRole from "../User/ViewAsignedRole.vue";
import { bus } from "../../main";
import DeleteCaution from "./DeleteCautionRole.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsRoles",
  components: {
    Select2,
    Pagination,
    ViewAsignedRole,
    DeleteCaution,
  },
  created() {
    if (!this.hasPermission("Role_View")) {
      this.$router.push("/restricted");
    }
    this.getRoles();
    this.getPermissions();
    bus.$on("viewDistRole", this.viewAdd);
  },
  watch: {},
  data() {
    return {
      filter: {
        status: "0",
        qry: "",
      },
      isBusy: false,
      isBusyModal: false,
      roleId: null,
      createRole: {
        name: null,
        permissions: [],
      },
      updateRole: {
        name: "",
        id: null,
        permissions: [],
      },
      editRole: {
        name: null,
        id: null,
        permissions: null,
      },
      v1: {
        name: false,
      },
      v2: {
        name: false,
      },
      roles: [],
      permissions: [],
      count: 0,
      page: 0,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      isModalVisible: false,
      role: {},
      loading: false,
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    permissionsListCreate() {
      return this.createRole.permissions.map((b) => {
        return b;
      });
    },
    permissionsListUpdate() {
      return this.updateRole.permissions.map((b) => {
        return b;
      });
    },
  },
  methods: {
    deleteRole(c) {
      this.roleId = c.id;
      this.role = c;
      $("#delete-role-modal").modal("show");
    },
    handleDeletionSuccess() {
      $("#delete-role-modal").modal("hide");
      this.getRoles();
      this.roleId = null;
    },
    onPermissionChange(item, state) {
      for (let child of item.children) {
        child.state.selected = state;
      }
    },
    reset() {
      this.filter = {
        status: "0",
        qry: "",
      };
    },
    cancel() {
      $("#mod-edit").modal("hide");
    },
    closeModal() {
      this.isModalVisible = !this.isModalVisible;
      this.getRoles();
    },
    async viewRoleUsers(r) {
      var roleId = r.id;
      let url = "/Roles/getAssignedUserList";
      this.isBusy = true;
      await this.$http
        .get(`${url}?page=` + 0 + "&pageSize=" + 10 + ("&roleId=" + roleId))
        .then(function(res) {
          this.roleUsers = res.body.data;
          this.isBusy = false;
        })
        .catch(function(err) {});
      this.roleInfo = { id: r.id, name: r.roleName };
      this.isModalVisible = true;
      this.isBusy = false;
    },
    viewAdd() {
      this.createRole = {
        name: null,
        permissions: JSON.parse(JSON.stringify(this.permissions)),
      };
      this.v1 = {
        name: false,
      };
      $("#mod-add").modal("show");
    },
    viewEdit(c) {
      var editValues = {
        name: c.roleName,
        id: c.id,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
      };
      this.editRole = editValues;

      this.updateRole = {
        id: c.id,
        name: c.roleName,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
      };

      $("#mod-edit").modal("show");
    },
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        name: this.createRole.name,
        parentId: this.user.parentId,
        roleType: this.user.type,
        permissions: this.createRole.permissions,
      };

      if (this.validateCreate()) {
        $("#mod-add").modal("hide");

        await this.$http
          .post("/Roles/create", data)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});

        this.getRoles();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateCreate() {
      this.v1 = {
        name: false,
      };
      var isValid = true;

      if (!this.createRole.name) {
        this.v1.name = true;
        isValid = false;
      }

      return isValid;
    },
    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      const data = {
        name: this.updateRole.name,
        permissions: this.updateRole.permissions,
        roleId: this.updateRole.id,
        parentId: this.user.parentId,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .put("/Roles/update/" + data.roleId, data)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});

        this.getRoles();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateUpdate() {
      this.v2 = {
        name: false,
      };
      var isValid = true;

      if (!this.updateRole.name) {
        this.v2.name = true;
        isValid = false;
      }

      return isValid;
    },
    async getRoles() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/Roles/getRoleList?page=" +
            this.page +
            "&pageSize=" +
            this.pageSize +
            "&roleType=" +
            this.user.type +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "")
        )
        .then(function(res) {
          this.roles = res.body.data;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
      this.loading = false;
    },
    async getPermissions() {
      this.isBusy = true;

      await this.$http
        .get("/Roles/getPermissionList?roleType=" + this.user.type)
        .then(function(res) {
          this.permissions = res.body;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
        })
        .catch(function() {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    prev() {
      this.page -= 1;
      this.getRoles();
    },

    next() {
      this.page += 1;
      this.getRoles();
    },

    gotoPage(page) {
      this.page = page - 1;
      this.getRoles();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getRoles();
    },
  },
};
</script>
